module.exports = __webpack_public_path__ + "static/media/lucia.5039d7dd.jpg";